exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1D-dKidG-index-module-with-room-for-header{padding-top:75px}.whUa-8ge-index-module-without-room-for-header{padding-top:0}", ""]);

// exports
exports.locals = {
	"with-room-for-header": "_1D-dKidG-index-module-with-room-for-header",
	"withRoomForHeader": "_1D-dKidG-index-module-with-room-for-header",
	"without-room-for-header": "whUa-8ge-index-module-without-room-for-header",
	"withoutRoomForHeader": "whUa-8ge-index-module-without-room-for-header"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/layout/MainContainer/index.module.scss
// module id = 1208
// module chunks = 0